import axios from "axios";

let currentMessage = null;
const listeners = new Set();

const notify = () => {
  listeners.forEach((cb) => cb(currentMessage));
};

export const subscribeUserDeleted = (cb) => {
  listeners.add(cb);
  cb(currentMessage);
  return () => listeners.delete(cb);
};

export const triggerUserDeleted = (message) => {
  if (currentMessage) return;
  currentMessage =
    message ||
    "Your account no longer exists. Please log out and log in again.";
  notify();
};

export const clearUserDeleted = () => {
  currentMessage = null;
  notify();
};

const isUserDeletedPayload = (data) =>
  data && typeof data === "object" && data.userDeleted === true;

const attachInterceptor = (instance) => {
  if (!instance || !instance.interceptors || instance.__userDeletedAttached) {
    return;
  }
  instance.interceptors.response.use(
    (response) => {
      if (isUserDeletedPayload(response?.data)) {
        // eslint-disable-next-line no-console
        console.log("[userDeleted] detected on success response", response?.config?.url);
        triggerUserDeleted(response.data.message);
      }
      return response;
    },
    (error) => {
      if (isUserDeletedPayload(error?.response?.data)) {
        // eslint-disable-next-line no-console
        console.log("[userDeleted] detected on error response", error?.config?.url);
        triggerUserDeleted(error.response.data.message);
      }
      return Promise.reject(error);
    },
  );
  instance.__userDeletedAttached = true;
};

let patched = false;
const patchAxiosCreate = () => {
  if (patched) return;
  patched = true;
  const originalCreate = axios.create.bind(axios);
  axios.create = (...args) => {
    const instance = originalCreate(...args);
    attachInterceptor(instance);
    return instance;
  };
};

// let fetchPatched = false;
// const patchFetch = () => {
//   if (fetchPatched) return;
//   if (typeof window === "undefined" || typeof window.fetch !== "function") {
//     return;
//   }
//   fetchPatched = true;
//   const originalFetch = window.fetch.bind(window);
//   window.fetch = (...args) => {
//     return originalFetch(...args).then((response) => {
//       try {
//         const contentType = response?.headers?.get?.("content-type") || "";
//         if (contentType.includes("application/json")) {
//           // Read a clone so the caller still gets an unread body.
//           response
//             .clone()
//             .json()
//             .then((data) => {
//               if (isUserDeletedPayload(data)) {
//                 // eslint-disable-next-line no-console
//                 console.log(
//                   "[userDeleted] detected on fetch response",
//                   args?.[0],
//                 );
//                 triggerUserDeleted(data.message);
//               }
//             })
//             .catch(() => {});
//         }
//       } catch (_) {
//         // never let the inspection break the caller
//       }
//       return response;
//     });
//   };
// };

export const setupUserDeletedInterceptor = (extraInstances = []) => {
  patchAxiosCreate();
  // patchFetch();
  attachInterceptor(axios);
  extraInstances.forEach(attachInterceptor);
};

// Auto-init at module load so the patch is in place before any
// `axios.create()` call in other modules executes.
setupUserDeletedInterceptor();
